var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Classes.AjaxXMLRequest = new Class({
    Extends: OCS.Classes.AjaxAbstractRequest,
    class_name: "AjaxXMLRequest",
    last_url: null,
    last_data: null,
    options: {
        url: '',
        url_keys: {},
        data: '',
        headers: {
            'Accept': 'text/javascript, text/html, application/xml, text/xml, */*'
        },
        async: true,
        format: false,
        method: 'post',
        link: 'ignore',
        isSuccess: null,
        emulation: true,
        urlEncoded: true,
        encoding: 'utf-8',
        evalScripts: false,
        evalResponse: false,
        corsRequest: true,
        timeout: 0,
        passthrough_ops: {},
        noCache: false,
        responseType: null
    },
    initialize: function (options) {
        this.xhr = new Browser.Request();
        this.parent(options);
        this.headers = this.options.headers;
        if (!this.options.corsRequest) {
            Object.append(this.headers, {'X-Requested-With': 'XMLHttpRequest'});
        }
    },

    onStateChange: function () {
        var xhr = this.xhr;
        if (xhr.readyState !== 4 || !this.running)
            return;
        this.running = false;
        this.status = 0;
        Function.attempt(function () {
            var status = xhr.status;
            this.status = (status === 1223) ? 204 : status;
        }.bind(this));
        xhr.onreadystatechange = Function.from;
        if (progressSupport)
            xhr.onprogress = xhr.onloadstart = Function.from;
        if (this.timer) {
            clearTimeout(this.timer);
            delete this.timer;
        }
        this.response = {"request": this};
        if (this.options.responseType && (this.options.responseType === 'arraybuffer' || this.options.responseType === 'blob' || this.options.responseType === 'json')) {
            this.response[this.options.responseType] = this.xhr.response || '';
        } else {
            if (!this.options.responseType) {
                try {
                    this.response.text = this.xhr.responseText || '';
                    this.response.xml = this.xhr.responseXML || '';
                } catch(err) {
                    this.response.text = '';
                    this.response.xml = '';
                }

            }
        }
        if (this.options.isSuccess.call(this, this.status))
            this.success(this.response);
        else
            this.failure();

    },
    processScripts: function (text) {
        if (typeof text !== 'string')
            return text;
        if (this.options.evalResponse || (/(ecma|java)script/).test(this.getHeader('Content-type')))
            return Browser.exec(text);
        if (text && text.stripScripts)
            return text.stripScripts(this.options.evalScripts);

        return text;
    },

    setHeader: function (name, value) {
        this.headers[name] = value;
        return this;
    },
    getHeader: function (name) {
        return Function.attempt(function () {
            return this.xhr.getResponseHeader(name);
        }.bind(this));
    },
    send: function (options) {
        if (!this.check(options))
            return this;



        this.options.isSuccess = this.options.isSuccess || this.isSuccess;
        this.running = true;

        var type = typeOf(options);
        if (type === 'string' || type === 'element')
            options = {data: options};

        var old = this.options;
        options = Object.append({data: old.data, url: old.url, method: old.method}, options);
        var data = options.data, url = String(options.url), method = options.method.toLowerCase();

        switch (typeOf(data)) {
            case 'element':
                data = document.id(data).toQueryString();
                break;
            case 'object':
            case 'hash':
                data = Object.toQueryString(data);
        }

        if (this.options.format) {
            var format = 'format=' + this.options.format;
            data = (data) ? format + '&' + data : format;
        }

        if (this.options.emulation && !['get', 'post'].contains(method)) {
            var _method = '_method=' + method;
            data = (data) ? _method + '&' + data : _method;
            method = 'post';
        }

        if (this.options.urlEncoded && ['post', 'put'].contains(method)) {
            var encoding = (this.options.encoding) ? '; charset=' + this.options.encoding : '';
            this.headers['Content-type'] = 'application/x-www-form-urlencoded' + encoding;
        }

        url = this.url_string_replace(url);


        if (!url)
            url = document.location.pathname;

        var trimPosition = url.lastIndexOf('/');
        if (trimPosition > -1 && (trimPosition = url.indexOf('#')) > -1)
            url = url.substr(0, trimPosition);

        if (this.options.noCache)
            url += (url.indexOf('?') > -1 ? '&' : '?') + String.uniqueID();

        if (data && (method === 'get' || method === 'delete')) {
            url += (url.indexOf('?') > -1 ? '&' : '?') + data;
            data = null;
        }

        if (this.response && this.successful && !this.options.noCache) {
            if (method === 'get' || method === 'delete' && this.last_url === url) {
                this.running = false;
                this.success(this.response);
                return this;
            }
            if (this.last_url === url && this.last_data === data) {
                this.running = false;
                this.success(this.response);
                return this;
            }
        }


        var xhr = this.xhr;
        if (progressSupport) {
            xhr.onloadstart = this.loadstart.bind(this);
            xhr.onprogress = this.progress.bind(this);
        }

        xhr.open(method.toUpperCase(), url, this.options.async, this.options.user, this.options.password);
        if ((this.options.withCredentials) && 'withCredentials' in xhr)
            xhr.withCredentials = true;

        if (this.options.responseType)
            xhr.responseType = this.options.responseType;

        xhr.onreadystatechange = this.onStateChange.bind(this);

        Object.each(this.headers, function (value, key) {
            try {
                xhr.setRequestHeader(key, value);
            } catch (e) {
                this.fireEvent('exception', [key, value]);
                this.reject({reason: 'exception', xhr: xhr, exception: e});
            }
        }, this);

        if (this.getThenableState() !== 'pending') {
            this.resetThenable({reason: 'send'});
        }
        this.fireEvent('request');
        xhr.send(data);
        if (!this.options.async)
            this.onStateChange();
        else if (this.options.timeout)
            this.timer = this.timeout.delay(this.options.timeout, this);

        this.last_url = url;
        this.last_data = data;
        return this;
    },
    cancel: function () {
        if (!this.running)
            return this;
        this.running = false;
        var xhr = this.xhr;
        xhr.abort();
        if (this.timer) {
            clearTimeout(this.timer);
            delete this.timer;
        }
        xhr.onreadystatechange = Function.from;
        if (progressSupport)
            xhr.onprogress = xhr.onloadstart = Function.from;
        this.xhr = new Browser.Request();
        this.fireEvent('cancel', this);
        this.reject({reason: 'cancel', xhr: xhr});
        this.onComplete();
        return this;
    },

});




